import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  TemplateRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";

@Component({
  selector: "i3jwt-default-container",
  templateUrl: "./default-container.component.html",
  styleUrls: ["./default-container.component.scss"],
})
export class DefaultContainerComponent implements OnInit, OnDestroy {
  idiomaActual: string;
  langSubscription?: Subscription;

  @Input() titulo: string;
  @Input() icono: any;
  @Input() template: TemplateRef<any>;
  @Input() salir: boolean = false;

  constructor(private translateServ: TranslateService, private router: Router) {
    this.idiomaActual = this.translateServ.currentLang;
  }

  ngOnInit() {
    this.langSubscription = this.translateServ.onLangChange.subscribe(() => {
      this.idiomaActual = this.translateServ.currentLang;
    });
  }

  ngOnDestroy(): void {
    this.langSubscription.unsubscribe();
  }

  changeLanguage(langKey: string) {
    this.translateServ.use(langKey);
  }

  volver(): void {
    this.router.navigate(["/home"]);
  }
}
